<template>
  <div>
    <v-dialog
        v-model="confirm_dialog"
        max-width="290"
        hide-overlay
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ confirm_title }}
        </v-card-title>

        <v-card-text>
          {{ confirm_body }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              text
              @click="sendConfirm(false)"
          >
            Disagree
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="sendConfirm(true)"
          >
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';

export default {
  name: 'BatchRunConfirmationDialog',

  components: {},

  computed: {
    ...mapGetters('BatchRunWeek', []),
    ...mapFields('BatchRunWeek', ['confirm_dialog', 'confirm_title', 'confirm_body',
      'confirm_result', 'confirm_type', 'confirm_parameters']),

  },

  methods: {
    ...mapActions('BatchRunWeek', ['fetchActionItem']),
    sendConfirm(confirm) {
      // console.log('sendConfirm', confirm)
      let parameters = {
        ... this.confirm_parameters,
        ... {confirm_dialog_result: confirm}
      }
      this.fetchActionItem({
        action_name: 'set_batch_run_delivery_date',
        id_list: [this.confirm_parameters.batch_run_id],
        parameters: parameters,
      })
      this.confirm_dialog = false
    },
  },

  async mounted() {
  },

  created() {
  },
  destroyed() {
  },

  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
</style>
